export class Estado {
    codigo: string;
    descripcion: string;

    constructor() {
        this.codigo = null;
        this.descripcion = null;
    }
}